import React from "react";
import CanalPanel from "./EstadisticasCanalPanel";

export default function EstadisticasCanal({ canal }) {
  const title = canal.toUpperCase();
  return (
    <div className="min-h-screen bg-[#006f91] text-white px-4 py-8">
      <div className="max-w-7xl mx-auto space-y-6">
        <header className="flex items-center justify-between">
          <h1 className="text-3xl font-bold">Estadísticas {title}</h1>
        </header>

        {/* Abanico Fijo */}
        <details open className="bg-white/10 rounded-xl border border-white/10">
          <summary className="cursor-pointer select-none px-4 py-3 text-lg font-semibold">
            Fijo
          </summary>
          <div className="px-4 pb-4">
            <CanalPanel canal={canal} tipo="fijo" />
          </div>
        </details>

        {/* Abanico Móvil */}
        <details className="bg-white/10 rounded-xl border border-white/10">
          <summary className="cursor-pointer select-none px-4 py-3 text-lg font-semibold">
            Móvil
          </summary>
          <div className="px-4 pb-4">
            <CanalPanel canal={canal} tipo="movil" />
          </div>
        </details>
      </div>
    </div>
  );
}
